// ** MUI Imports
import {
  GridColumnHeaders,
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import React from "react";

import { LinearProgress } from "@mui/material";
import MuiPagination from "@mui/material/Pagination";
import { Box } from "@mui/system";
import {
  StyledDataGrid,
  StyledGridPagination,
} from "../../common/Utils/StyledComponents";
import NoDataFound from "../ManageTask/NoDataFound";
import ListShimmer from "../../common/Shimmer/ListShimmer";
import NoMailSync from "../InboxModule/Components/NoMailSyncMessage";
import Translate from "../../translation/utils/translateFunction";

const ListView = ({
  columns,
  rows,
  total,
  onPaginationChange,
  currentPage = 1,
  totalPageCount = 0,
  isExpandedTable = false,
  rowsPerPage = 10,
  showColumnShowHide = false,
  hideColumnHeaders = false,
  showDynamicRowHeight = false,
  initialState,
  autoHeight,
  showShimmer,
  showLoader,
  hidePagination,
  sortBy = false,
  isInbox = false,
  noDataMessage = Translate("common:noDataFoundMessage"),
  ...props
}) => {
  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{ py: 5, justifyContent: "end" }}>
        <GridToolbarColumnsButton sx={{ paddingRight: 0, marginRight: -3 }} />
      </GridToolbarContainer>
    );
  }
  function Pagination({ className, onPageChange }) {
    return (
      <MuiPagination
        color="primary"
        className={className}
        count={totalPageCount}
        page={currentPage}
        onChange={(event, newPage) => {
          onPageChange(event, newPage - 1);
          onPaginationChange(newPage);
        }}
      />
    );
  }

  function CustomPagination() {
    return (
      <StyledGridPagination
        rowsPerPage={rowsPerPage}
        ActionsComponent={Pagination}
      />
    );
  }

  return (
    <>
      {showLoader && (
        <Box sx={{ width: "100%", padding: "20px 10px 0px 10px" }}>
          <LinearProgress style={{ height: 2 }} />
        </Box>
      )}
      {showShimmer ? (
        <ListShimmer />
      ) : (
        rows && (
          <StyledDataGrid
            localeText={{
              toolbarColumns: (
                <span style={{ fontSize: 10, textTransform: "lowercase" }}>
                  {""}
                </span>
              ),
              // noRowsLabel:<NoDataFound isCenter />,
              noRowsLabel: isInbox ? (
                <NoMailSync isCenter />
              ) : (
                <NoDataFound isCenter message={noDataMessage} />
              ),
            }}
            sortingOrder={sortBy ? ["desc"] : ["asc"]}
            autoHeight={autoHeight}
            slots={{
              toolbar: showColumnShowHide ? CustomToolbar : null,
              pagination: hidePagination ? null : CustomPagination,
              columnHeaders: hideColumnHeaders ? () => null : GridColumnHeaders,
            }}
            initialState={{
              pagination: { paginationModel: { pageSize: rowsPerPage } },
              ...initialState,
            }}
            pageSizeOptions={[rowsPerPage]}
            rows={rows}
            paginationMode="client"
            style={{ height: isExpandedTable ? "420px" : "700px" }}
            componentsProps={{
              panel: {
                placement: "bottom-end",
              },
            }}
            getRowClassName={(param) =>
              param?.indexRelativeToCurrentPage % 2 !== 0 ? "tableStrip" : null
            }
            hideFooterSelectedRowCount
            columns={columns}
            getRowId={(row) => row?._id || row?.userId || row?.date}
            getRowHeight={() => (showDynamicRowHeight ? "auto" : 50)}
            {...props}
          />
        )
      )}
    </>
  );
};

export default ListView;
